import { Navigate } from "react-router-dom";
import useAuth from "../auth/useAuth";
import type { JSX } from "react";
import FullScreenLoading from "../components/common/FullScreenLoading";

export default function ProtectedRoute({
  children,
}: {
  children: JSX.Element;
}) {
  const { data, isLoading } = useAuth();

  if (isLoading) {
    return <FullScreenLoading />;
  }

  if (!data?.user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
